import { Link } from "wouter";
import { SiYoutube, SiDiscord, SiFacebook, SiTelegram, SiTiktok, SiInstagram } from "react-icons/si";

export default function Footer() {
  const socialLinks = [
    {
      href: "https://www.youtube.com/@mestrecacatal",
      icon: SiYoutube,
      label: "YouTube Channel"
    },
    {
      href: "https://discord.com/invite/ZFP4QrWney",
      icon: SiDiscord,
      label: "Discord Server"
    },
    {
      href: "https://facebook.com/groups/1436355617246687",
      icon: SiFacebook,
      label: "Facebook Group"
    },
    {
      href: "https://t.me/bpuzzles",
      icon: SiTelegram,
      label: "Telegram Group"
    },
    {
      href: "https://www.tiktok.com/@mestrecacatal",
      icon: SiTiktok,
      label: "TikTok"
    },
    {
      href: "https://www.instagram.com/mestrecacatal/",
      icon: SiInstagram,
      label: "Instagram"
    }
  ];

  return (
    <footer className="mt-auto border-t border-zinc-800 bg-black text-zinc-400">
      <div className="container mx-auto px-6 py-4">
        <div className="flex flex-col gap-4">
          <div className="flex items-center justify-center gap-6">
            {socialLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
                title={link.label}
              >
                <link.icon className="w-5 h-5" />
                <span className="sr-only">{link.label}</span>
              </a>
            ))}
          </div>
          <div className="flex items-center justify-between">
            <div className="text-sm">
              © {new Date().getFullYear()} BitcoinPuzzles. All rights reserved.
            </div>
            <nav className="flex gap-4 text-sm">
              <Link 
                href="/privacy" 
                className="hover:text-white transition-colors"
              >
                Privacy Policy
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}